<div
    class="contract-start-picker"
    [formGroup]="startDateForm"
>
    <div class="picker-elements">
        @if (mode !== 'month') {
            <div class="form-control day-container m-0:b">
                <select
                    formControlName="day"
                    [attr.aria-labelledby]="labelledById + ' unit-days'"
                    required
                >
                    <option
                        id="unit-days"
                        disabled="disabled"
                        [value]="null"
                        aria-hidden="true"
                    >
                        Tag
                    </option>
                    @for (day of days; track day) {
                        <option [ngValue]="day">{{ day }}</option>
                    }
                </select>
            </div>
        }
        <div class="form-control month-container m-0:b">
            <select
                formControlName="month"
                required
                [attr.aria-labelledby]="labelledById + ' unit-month'"
            >
                <option
                    id="unit--month"
                    disabled="disabled"
                    [value]="null"
                    aria-hidden="true"
                >
                    Monat
                </option>
                @for (month of months; track month.date) {
                    <option [ngValue]="month.date">{{ month.label }}</option>
                }
            </select>
        </div>
    </div>
</div>
